import React from "react";
import clsx from "clsx";
import styles from "./Summary.module.scss";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import { useTabsContext } from "./SummaryTabsContext";
import { CarConfigLabel, useCarConfigOptionalLabel } from "../../../../../utils/labelUtils";
import Price from "../../../common/price/Price";
import { useCarConfigSelector } from "../../../../../redux/store";
import type { SummaryTabPropsTypes } from "../../../../../hooks/useAphSummaryTabs";
import SummaryServices from "./SummaryServices";
import SummaryManufacturerInfo from "./SummaryManufacturerInfo";

const SummaryCash = (props: SummaryTabPropsTypes): JSX.Element | null => {
    const { tabId, tab } = props;
    const tabsContext = useTabsContext();
    const carConfigCashPriceDisclaimer = useCarConfigOptionalLabel("carConfigCashPriceDisclaimer");
    const basketTotal = useCarConfigSelector((state) => state.basket.total);

    return (
        <section
            role="tabpanel"
            id={tabId}
            aria-labelledby={tab}
            className={clsx(styles["tab-panel"], styles.finance)}
            hidden={tabsContext.openTab !== "cash"}
        >
            <Text tag="h3" variant="apheleia-h4">
                <CarConfigLabel label="carConfigCashPurchase" />
            </Text>
            <div className={styles["price-row"]}>
                <Text tag="h4" variant="apheleia-body">
                    <strong>
                        <CarConfigLabel label="carConfigCashTotal" />
                    </strong>
                </Text>
                <Text tag="h4" variant="apheleia-body">
                    <strong>
                        <Price price={basketTotal} forceCashPrice financeItemId="total" />
                    </strong>
                </Text>
            </div>
            <Text className={styles["cash-disclaimer"]} variant="apheleia-h5">
                {carConfigCashPriceDisclaimer}
            </Text>

            <SummaryServices />
            <SummaryManufacturerInfo />
        </section>
    );
};

export default SummaryCash;
